export const config = {
  title: 'Unique top-tier expertise',
  subtitle: (
    <>
      The top-notch level of services we provide is officially confirmed
      <br />
      by the best IT industry ratings.
    </>
  ),
  ids: [
    'todevelopers-software',
    'goodfirms-devops',
    'businessfirms',
    'techreviewer',
    'itrate',
  ],
}
